import { render, staticRenderFns } from "./EndDate.vue?vue&type=template&id=631d3d36"
import script from "./EndDate.vue?vue&type=script&lang=js"
export * from "./EndDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports